import _import from './_import.js';
// import where_to_buy from '../views/glocalme/where_to_buy';

export default [
    // 流量商城
    {
        path: 'data_package/index',
        name: 'data_package/index',
        component: _import('data_package')
    },
	// 套餐购买结算
    {
        path: 'data_package/settlement',
        name: 'settlement',
        component: _import('data_package/settlement')
    },
    {
        path: 'data_package/payResult',
        name: 'payResult',
        component: _import('data_package/payResult'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: 'data_package/select',
        name: 'select',
        component: _import('data_package/select_area')
    },
    {
        path: 'data_package/:country',
        name: 'data_package/country',
        component: _import('data_package')
    }
];


// WEBPACK FOOTER //
// ./src/router/data_package.js